export const CLINICAL_ANALYSIS_TYPES_ACTIONS = {
    GET_ALL: 'CLINICAL_ANALYSIS_TYPES_GET_ALL',
    GET_ACTIVE: 'CLINICAL_ANALYSIS_TYPES_GET_ACTIVE',
    FIND: 'CLINICAL_ANALYSIS_TYPES_FIND',
    CLEAN: 'CLINICAL_ANALYSIS_TYPES_CLEAN',
    CHANGE_STATUS: 'CLINICAL_ANALYSIS_TYPES_CHANGE_STATUS',
    SUCCESS: 'CLINICAL_ANALYSIS_TYPES_SUCCESS',
    ERROR: 'CLINICAL_ANALYSIS_TYPES_ERROR',

    GET_METHODOLOGIES: 'CLINICAL_ANALYSIS_TYPES_GET_METHODOLOGIES',
    GET_RESULTS: 'CLINICAL_ANALYSIS_TYPES_GET_RESULTS',
}